<template>
  <validation-observer tag="div" ref="form">
    <validation-provider
      vid="name"
      :name="lodash.upperFirst($t('tickets.type'))"
      rules="required"
      v-slot="{ validated, errors }"
    >
      <b-form-group
        class="row mb-3 "
        label-cols-md="12"
        :label="lodash.upperFirst($t('tickets.choose')) + '*'"
        :state="errors[0] ? false : validated ? true : null"
        :invalid-feedback="errors[0]"
      >
        <template #label>
          <div class="text-block text-neutral-default">
            {{ lodash.upperFirst($t("tickets.type")) }}
          </div>
        </template>
        <b-form-select v-model="model.customer_type" :options="options"></b-form-select>
      </b-form-group>
    </validation-provider>
    <div class="bg-primary-subdued text-primary p-16px rounded text-block-md" v-if="model.customer_type">
      <div v-if="model.customer_type === 'brs'">
        {{ $t("tickets.customer_types.brs") }} digunakan untuk transaksi yang tidak melibatkan kegiatan pengiriman
        (armada) oleh pihak JALA.<br />
        Produk-produk yang menggunakan {{ $t("tickets.customer_types.brs") }} sebagai berikut:
      </div>
      <div v-if="model.customer_type === 'lcs'">
        {{ $t("tickets.customer_types.lcs") }} digunakan untuk transaksi yang melibatkan kegiatan pengiriman (armada)
        oleh pihak JALA.<br />
        Produk-produk yang menggunakan {{ $t("tickets.customer_types.lcs") }} sebagai berikut:
      </div>
      <div class="mt-10px">
        <ul class="mb-0">
          <li :key="product" v-for="product in products[model.customer_type]">
            {{ product }}
          </li>
        </ul>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import FormModel from "./model";

export default {
  extends: FormModel,
  data() {
    return {
      model: {
        ...this.value,
        customer_type: this.value.customer_type ? this.value.customer_type : null
      },
      options: [
        { value: null, text: "Pilih Tipe" },
        { value: "brs", text: this.$t("tickets.customer_types.brs") },
        { value: "lcs", text: this.$t("tickets.customer_types.lcs") }
      ],
      products: {
        brs: ["Basic", "Pro", "Pro Plus"],
        lcs: ["KM", "NP", "FRS", "JP"]
      }
    };
  }
};
</script>
